var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightLightTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3337 13.9993C27.3337 17.5356 25.9289 20.927 23.4284 23.4274C20.9279 25.9279 17.5365 27.3327 14.0003 27.3327C12.2494 27.3327 10.5156 26.9878 8.89788 26.3177C7.2802 25.6477 5.81035 24.6656 4.57223 23.4274C2.07175 20.927 0.666992 17.5356 0.666992 13.9993C0.666992 10.4631 2.07175 7.07174 4.57223 4.57126C7.07272 2.07077 10.4641 0.666016 14.0003 0.666016C15.7513 0.666016 17.4851 1.01089 19.1028 1.68096C20.7204 2.35102 22.1903 3.33314 23.4284 4.57126C24.6665 5.80937 25.6487 7.27923 26.3187 8.8969C26.9888 10.5146 27.3337 12.2484 27.3337 13.9993ZM6.00033 15.3327H16.667L12.0003 19.9993L13.8937 21.8927L21.787 13.9993L13.8937 6.10602L12.0003 7.99935L16.667 12.666H6.00033V15.3327Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightLightTheme);
export default __webpack_public_path__ + "static/media/arrowRightLightTheme.59a846b29978f05bbe27325d786e9a83.svg";
export { ForwardRef as ReactComponent };